import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Form,
  InputGroup,
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Spinner,
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
//Import Flatepicker
import 'flatpickr/dist/themes/material_blue.css';
import Flatpickr from 'react-flatpickr';
import { useUrlSearchParams } from 'use-url-search-params';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import { ExportToExcel } from '../ExportToExcel';
import toast, { Toaster } from 'react-hot-toast';
import { excelGenerate } from '../actions/orderActions';

function OrderExportReport(props) {
  const [isactive] = useUrlSearchParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const [data, setData] = React.useState([]);
  const { afterToday, combine, allowedMaxDays } = DateRangePicker;
  const [isExportEnable, setisExportEnable] = useState(false);
  const [isTypeError, setisTypeError] = useState(false);
  const [isDateError, setisDateError] = useState(false);
  const [startDate, setStartDate] = useState(
    new moment(new Date()).format('YYYY-MM-DD'),
  );

  const [endDate, setEndDate] = useState(
    new moment(new Date()).format('YYYY-MM-DD'),
  );
  const [excelExportReport, setexcelExportReport] = useState(false);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  let isMobileView = 0;
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  if (windowSize.innerWidth <= 1279 && isMobileView === 0) {
    isMobileView++;
  }

  const { country = [] } = useSelector((state) => state.country);
  const [orderMode, setOrderMode] = useState('All');

  const splitVal = location?.pathname.split('/');
  useEffect(() => {
    if (splitVal[1] === 'splitorders') {
      // orderMode = "split"
      setOrderMode('split');
    } else if (splitVal[1] === 'b2borders') {
      setOrderMode('b2b');
    } else if (splitVal[1] === 'storeorders') {
      setOrderMode('store');
    } else if (splitVal[1] === 'bulkorders') {
      setOrderMode('bulk');
    } else {
      setOrderMode('All');
    }
  }, [splitVal]);
  const handleSubmit = (event) => {
    setexcelExportReport(true);
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const exportType = event.target.elements.export_type.value;

    setisTypeError(exportType === '' ? true : false);

    if (exportType !== '') {
      excelGenerate({
        params: {
          export_type: exportType,
          date_from: startDate,
          date_to:
            endDate === undefined || endDate === '' ? startDate : endDate,
          country: country,
          status: isactive?.activeTab,
          is_kioskorder: props?.is_kioskorder || 0,
        },
        dispatch,
      });

      // setisExportEnable(true);
    }
  };
  const { generateFile = [], generateFileLoading } = useSelector(
    (state) => state.order,
  );
  useEffect(() => {
    setexcelExportReport(false);
    if (generateFile?.code === 100) {
      toast.success(generateFile?.message, {
        style: {
          border: '1px solid #fff',
          padding: '20px',
          color: '#ffffff',
          background: '#4CAF50',
        },
        iconTheme: {
          primary: '#FFFAEE',
          secondary: '#4CAF50',
        },
      });
    } else {
      if (generateFile?.message) {
        toast.error(generateFile?.message, {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
      }
    }
  }, [generateFile]);
  let dropDownvalue = '';
  if (orderMode === 'All') {
    dropDownvalue = 'online_orders';
  } else if (orderMode === 'split') {
    dropDownvalue = 'online_split_orders';
  } else if (orderMode === 'b2b') {
    dropDownvalue = 'online_bb_orders';
  } else if (orderMode === 'bulk') {
    dropDownvalue = 'online_bulk_orders';
  } else {
    dropDownvalue = 'online_store_orders';
  }
  let itemSummary = '';
  let installation_order = '';
  if (orderMode === 'All' || orderMode === 'split') {
    itemSummary = 'item_summery';
    installation_order = 'installation_orders';
  } else if (orderMode === 'b2b') {
    itemSummary = 'item_bb_summery';
  } else {
    itemSummary = 'item_store_summery';
  }

  return (
    <>
      <Col xl={4} style={{ marginBottom: '20px' }}>
        <Row className="align-items-end">
          <Form onSubmit={handleSubmit}>
            <Col xl={12} className="textAlignRigh">
              <div className="DashbordFliter ">
                <div className="InputBg">
                  <Input type="select" name="export_type" id="exampleSelect">
                    <option value="">Choose Export Report Type</option>
                    <option value={dropDownvalue}>Online Sale</option>
                    {orderMode !== 'bulk' ? (
                      <>
                        {' '}
                        <option value={itemSummary}>Order Item Summary</option>
                      </>
                    ) : null}
                    <option value={installation_order}>
                      Installation Orders
                    </option>
                    <option value="coupon_list">Coupon Report</option>
                    <option value="conversion_report">
                      Item Conversion Report
                    </option>
                  </Input>
                  {isTypeError && (
                    <span
                      style={{
                        position: 'absolute',
                        top: 40,
                        fontSize: 12,
                        left: 0,
                        color: '#f00',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      Please Select Export Type.
                    </span>
                  )}
                </div>
                <div className="InputBg">
                  {isMobileView !== 0 ? (
                    <>
                      <DateRangePicker
                        placement="auto"
                        placeholder="Select Date Range"
                        onClean={() => {
                          setStartDate(
                            new moment(new Date()).format('YYYY-MM-DD'),
                          );
                          setEndDate(
                            new moment(new Date()).format('YYYY-MM-DD'),
                          );
                        }}
                        showOneCalendar
                        disabledDate={combine(allowedMaxDays(31), afterToday())}
                        onChange={(selectedDates, instance) => {
                          const dateStr = selectedDates?.[0];
                          const first_Date = new Date(dateStr)?.toString();
                          const firstD = moment(new Date(first_Date))?.format(
                            'YYYY/MM/DD',
                          );
                          const firstDateReplace = firstD?.replaceAll('/', '-');
                          const dateStr1 = selectedDates?.[1];
                          const second_Date = new Date(dateStr1)?.toString();
                          const secondD = moment(new Date(second_Date))?.format(
                            'YYYY/MM/DD',
                          );
                          const secondDateReplace = secondD?.replaceAll(
                            '/',
                            '-',
                          );
                          setStartDate(firstDateReplace);
                          setEndDate(secondDateReplace);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <DateRangePicker
                        placement="leftStart"
                        placeholder="Select Date Range"
                        onClean={() => {
                          setStartDate(
                            new moment(new Date()).format('YYYY-MM-DD'),
                          );
                          setEndDate(
                            new moment(new Date()).format('YYYY-MM-DD'),
                          );
                        }}
                        disabledDate={combine(allowedMaxDays(31), afterToday())}
                        onChange={(selectedDates, instance) => {
                          const dateStr = selectedDates?.[0];
                          const first_Date = new Date(dateStr)?.toString();
                          const firstD = moment(new Date(first_Date))?.format(
                            'YYYY/MM/DD',
                          );
                          const firstDateReplace = firstD?.replaceAll('/', '-');
                          const dateStr1 = selectedDates?.[1];
                          const second_Date = new Date(dateStr1)?.toString();
                          const secondD = moment(new Date(second_Date))?.format(
                            'YYYY/MM/DD',
                          );
                          const secondDateReplace = secondD?.replaceAll(
                            '/',
                            '-',
                          );
                          setStartDate(firstDateReplace);
                          setEndDate(secondDateReplace);
                        }}
                      />{' '}
                    </>
                  )}
                  {isDateError && (
                    <span
                      style={{
                        position: 'absolute',
                        top: 40,
                        left: 0,
                        color: '#f00',
                      }}
                    >
                      Please Select Export Date.
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-dark"
                  style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  disabled={excelExportReport === true}
                >
                  {excelExportReport === true ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Exporting...
                    </>
                  ) : (
                    <>
                      Export{' '}
                      <i
                        className="bx bx-download"
                        style={{ padding: '3px' }}
                      ></i>
                    </>
                  )}
                </button>
              </div>
            </Col>
          </Form>
        </Row>
      </Col>
      {/* {isExportEnable?<ExportToExcel apiData={data} fileName={fileName}/>:null} */}
    </>
  );
}
export default OrderExportReport;
